import { Button, Card, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import InfoTooltip from '../components/InfoTooltip';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { useSearchParams } from 'react-router-dom';
import { CLIENT_ID, CLIENT_SECRET } from '../constant/constant';
import { createSmartThingsSettings, getSmartThingsSettings } from '../helper/backend_helper';

const SmartHomeSettings = () => {
  const [searchParams] = useSearchParams();
  const [smartThingsSettingsData, setSmartThingsSettingsData] = useState({});
  console.log(smartThingsSettingsData);

  useEffect(() => {
    const code = searchParams.get('code');

    if (code) {
      exchangeCodeForToken(code);
    }
  }, [searchParams]);

  const exchangeCodeForToken = async (code) => {
    try {
      const username = CLIENT_ID;
      const password = CLIENT_SECRET; // 
      // const credentials = Buffer.from(`${username}:${password}`).toString('base64');
      // const credentials = btoa(`${username}:${password}`);
      const response = await axios.post(
        'https://api.smartthings.com/oauth/token',
        new URLSearchParams({
          client_id: CLIENT_ID,
          grant_type: 'authorization_code',
          redirect_uri: 'https://admin.timelesspuglia.com/smart-home/settings',
          code,
        }),
        {
          auth: {
            username: CLIENT_ID,
            password: CLIENT_SECRET,
          },
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            // Authorization: `Basic ${credentials}`,
          },
        }
      );

      const accessToken = response.data.access_token;
      const refreshToken = response.data.refresh_token;
      console.log('Access Token:', accessToken);
      console.log('Refresh Token:', refreshToken);
      const expiryDate = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
      console.log(expiryDate.toISOString());

      const BannerData = {
        access_token: accessToken,
        refresh_token: refreshToken,
        expiryDate: expiryDate.toISOString(),
      };

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const res = await createSmartThingsSettings(BannerData, Categoryheaders);
      console.log(res);
    } catch (error) {
      console.error('Error exchanging code for token:', error);
    }
  };

  const Banner = async () => {
    try {
      const bannerResponse = await getSmartThingsSettings();
      setSmartThingsSettingsData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);

  const handleLogin = () => {
    try {
      const URL = `https://api.smartthings.com/oauth/authorize?client_id=${CLIENT_ID}&response_type=code&redirect_uri=https://admin.timelesspuglia.com/smart-home/settings&scope=r:devices:*+w:devices:*+x:devices:*`;
      window.location.href = URL;
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Helmet>
        <title> Smart Things </title>
      </Helmet>

      <Card sx={{ padding: 3 }}>
        <Stack mb={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h4">Settings{' '}<InfoTooltip width={20} title="The SmartThings connection settings that let the platform read and control smart-home devices through the SmartThings API. Press Login to authorise the integration via SmartThings OAuth, which stores the access and refresh tokens used by every device sync. The expiry date below shows when the current authorisation will lapse, so reconnect before then to keep devices in sync." /></Typography>
        </Stack>
        <Button onClick={handleLogin} sx={{ bgcolor: '#1E3A5F' }} variant="contained">
          Login
        </Button>

        <Typography mt={3} variant="h5">Expiry Date: {new Date(smartThingsSettingsData?.expiryDate).toLocaleDateString()}</Typography>
      </Card>
    </>
  );
};

export default SmartHomeSettings;
